// Shared label vocabulary for the coaching family (Coaching Tickets, the
// Coaching Board, and the sign-off modal). Backend contract mirror
// (ops_desk/coaching_service.py): the comment gate, statuses and outcomes
// must match or the UI lies about what will save.
export const MIN_COMMENT_LENGTH = 10
export const OPEN_STATUSES = ['open', 'scheduled']
// acknowledgement is an attribute of the sign-off, not a status (the api
// normalises legacy rows before they reach us) — this is the badge for it
export const ACK_LABEL = 'Acknowledged in person'
export const CLOSED_STATUSES = ['completed']

export const STATUS_LABELS = { open: 'Open', scheduled: 'Scheduled', completed: 'Completed' }
export const STATUS_VARIANTS = { open: 'danger', scheduled: 'warning', completed: 'success' }
export const STATUS_ICONS = { open: 'fa-circle-o', scheduled: 'fa-calendar', completed: 'fa-check' }
export const SOURCE_LABELS = { scorecard_kpi: 'Scorecard KPI', erm_event: 'ERM Event', accident: 'Accident', manual: 'Manual' }
export const SOURCE_VARIANTS = { scorecard_kpi: 'primary', erm_event: 'warning', accident: 'danger', manual: 'secondary' }

export const OUTCOME_OPTIONS = [
  { value: 'delivered', text: 'Delivered' },
  { value: 'retraining_scheduled', text: 'Retraining scheduled' },
  { value: 'written_warning', text: 'Written warning issued' },
  { value: 'dismissed_not_at_fault', text: 'Dismissed — not the driver’s fault' },
]
// recognition closes with its own vocabulary — mirrors RECOGNITION_OUTCOMES
// in ops_desk/coaching_service.py
export const RECOGNITION_OUTCOME_OPTIONS = [
  { value: 'recognized_in_person', text: 'Recognized in person' },
  { value: 'huddle_shoutout', text: 'Huddle shout-out' },
  { value: 'reward_issued', text: 'Reward issued' },
  { value: 'note_sent', text: 'Note sent' },
]

export const statusLabel = s => STATUS_LABELS[s] || s
export const statusVariant = s => STATUS_VARIANTS[s] || 'secondary'
export const statusIcon = s => STATUS_ICONS[s] || 'fa-circle-o'
export const sourceLabel = s => SOURCE_LABELS[s] || s
export const sourceVariant = s => SOURCE_VARIANTS[s] || 'secondary'
export const outcomeLabel = o => {
  const opt = OUTCOME_OPTIONS.find(x => x.value === o)
    || RECOGNITION_OUTCOME_OPTIONS.find(x => x.value === o)
  return opt ? opt.text : o
}
